import React, { useEffect, useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";
import gold from "../../../../../assets/icons/asset-icons/gold.svg";
import Button from "../../../../common/Button/Button";
import CopyBtn from "../../../../common/CopyBtn/CopyBtn";
import Table from "../../../../common/Table/Table";
import Tooltip from "../../../../common/Tooltip/Tooltip";
import TransactionTypeBadge from "../TransactionTypeBadge/TransactionTypeBadge";
import styles from "../Orders.module.scss";
import { getType } from "../Orders";
import OrderDetailsCompleted from "../../../../common/Modals/OrderDetailsCompleted/OrderDetailsCompleted";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { userSellWithUsHistoryAction } from "../../../../../features/user/userSlice";
import { formatPrice, toFix } from "../../../../../utils/utils";
import Commonpagination from "../../../../common/Pagination/Commonpagination";
import { useDebounce } from "../../../../customHook/useDebeunce";

const CompletedOrders = () => {
  const dispatch = useDispatch();
  const search = useOutletContext();
  const [orders, setOrders] = useState({});
  const [orderId, setOrderId] = useState({ orderId: "", transactionId: "" });
  const [imageURL, setImageURL] = useState("");
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const pageSize = 10;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();

  const [quantityOrder, setQuantityOrder] = useState(false);
  const [priceOrder, setPriceOrder] = useState(false);
  const [dateFilter, setDateFilter] = useState(false);
  const debounced = useDebounce(search, 500);
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);

  const fields = [
    { label: "Order ID" },
    { label: "Asset" },
    { label: "Type" },
    { label: "Qty", sort: true },
    { label: "Price", sort: true },
    { label: "Total" },
    { label: "Date", sort: true },
    { label: "Status" },
    // { label: "Actions" },
  ];

  const getTransactions = async (data) => {
    setLoading(true);
    try {
      const params = {
        page: page,
        size: pageSize,
        // filterByStatus: "COMPLETED",
      };
      // if (debounced) {
      //   params.searchKeyword = debounced;
      // }
      // if (data === "Qty") {
      //   params.sortByQuantity = quantityOrder == true ? "ASC" : "DESC";
      // }
      // if (data === "Date") {
      //   params.sortByDate = dateFilter == true ? "ASC" : "DESC";
      // }
      // if (data === "Price") {
      //   params.sortByPrice = priceOrder == true ? "ASC" : "DESC";
      // }

      const response = await dispatch(userSellWithUsHistoryAction(params));
      if (response.status === 200) {
        setOrders(response.data.data.rows);
        setTotalPages(response?.data?.data?.totalPages);
        setImageURL(response.data.data.tokenImageUrl);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getStatus = (status) => {
    if (status === "completed" || status === "delivered") {
      return styles.green;
    } else if (status === "cancelled") {
      return styles.red;
    } else {
      return "";
    }
  };

  const openDetailModal = (orderId, transactionId) => {
    setOrderId({ orderId, transactionId });
    setShow(true);
  };

  const callBackOnClick = (data) => {
    if (data === "Qty") {
      setQuantityOrder((prevIsTrue) => !prevIsTrue);
      getTransactions(data);
    }
    if (data === "Price") {
      setPriceOrder((prevIsTrue) => !prevIsTrue);
      getTransactions(data);
    }
    if (data === "Date") {
      setDateFilter((prevIsTrue) => !prevIsTrue);
      getTransactions(data);
    }
  };
  useEffect(() => {
    getTransactions();
  }, [page, debounced]);

  return (
    <>
      <Table
        noRecordContent={"No records for your search were found."}
        fields={fields}
        className={styles.table}
        loading={loading}
        noRecordVariant={"large"}
        noRecordClassName={styles.no_content}
        onClick={callBackOnClick}
        loadingClassName={"loading_table"}
      >
        {orders?.length > 0 &&
          orders?.map((item, index) => (
            <tr key={index}>
              <td>
                <Tooltip
                  icon={
                    <span>
                      {(item?.order_uid).slice(0, 5) +
                        "...." +
                        (item?.order_uid).slice(-5)}
                    </span>
                  }
                  content={
                    <>
                      <CopyBtn text={item?.order_uid} /> {item?.order_uid}
                    </>
                  }
                  className={styles.order_uid}
                />
              </td>
              <td className={styles.asset}>
                <img
                  src={`${imageURL}${item?.master_tokens_configuration?.image}`}
                  alt={item?.master_tokens_configuration?.name}
                />
                {item.master_tokens_configuration?.name}
              </td>
              <td>
                <TransactionTypeBadge type={getType(item.type)}>
                  {item?.order_type}
                </TransactionTypeBadge>
              </td>
              <td>
                {toFix(
                  Number(item?.quantity),
                  decimalLimit[item?.master_tokens_configuration?.name]
                )}
              </td>
              <td>{formatPrice(Number(item?.price))}</td>
              <td>${formatPrice(Number(item?.price * item?.quantity))}</td>
              <td>{format(new Date(item?.created_at), "dd MMM, yyyy")}</td>
              <td
                className={`${styles.status} ${getStatus(
                  item?.status
                )} text-capitalize`}
              >
                {item?.order_status?.toLowerCase()}
              </td>
              {/* <td>
                <Button
                  variant="text_blue"
                  onClick={() => openDetailModal(item?.order_id, item?.id)}
                  className={styles.detail_btn}
                >
                  Details
                </Button>
              </td> */}
            </tr>
          ))}
      </Table>
      {/* {transactions?.length > 0 && <Pagination pageCount={3} />} */}
      {orders?.length > 0 && (
        <Commonpagination
          // className={classpagonation}
          currentPage={page}
          totalPages={totalPages}
          handlePageChange={(selected) => setPage(selected)}
        />
      )}
      <OrderDetailsCompleted
        show={show}
        handleClose={() => setShow(false)}
        orderId={orderId}
      />
    </>
  );
};

export default CompletedOrders;
